import featuresJson from '../../generated/features.json'

const FEATURE_KEYS = [
  'appBranding',
  'iubenda',
  'onoffice',
  'company',
  'supportContact',
  'consulting',
  'signup',
  'dataPrivacy',
  'partner',
  'sso',
  'lpEigentumsRadar',
]

const featureConfig = Object.fromEntries(FEATURE_KEYS.map((key) => [key, featuresJson[key] || {}]))

const createFeatureProxy = <T extends Record<string, unknown>>(key) => {
  return new Proxy<T>({} as T, {
    get: (target, prop): T => {
      const value = featureConfig[key]?.[prop]
      return value ?? null
    },
  })
}

type Platform = 'markero' | 'bottimmo' | 'smg' | 'remax'

type CompanyFeature = {
  config: {
    isColorEditable: {
      app: boolean
      backoffice: boolean
    }
    isLogoEditable: {
      app: boolean
      backoffice: boolean
    }
    availableCountryCodes: string[]
    availableProductTypes: string[]
    companyDefaults: Record<string, unknown>
    isCompanyLanguageEditable: boolean
    isMetaCompanyDataEditable: boolean
    isAiSettingsVisible: boolean
    isSloganEditable: boolean
    isCommissionEditable: boolean
    isRegionEditable: boolean
    isOtherCompanyDataEditable: boolean
    isPhoneVerificationEditable: boolean
    isSalutationEditable: boolean
    isSlugEditable: boolean
    showLeadInteractivity: boolean
    showLeadStatistics: boolean
    platform: Platform
  }
}

type AppBranding = {
  config: {
    primary: string
    secondary: string
    platform: Platform
    readablePlatformName: string
    assetUrl: string
    dataPrivacyUrl: string
    upgradePackageUrl: string
    dataPrivacyUrlLoggedIn: string
    imprintUrl: string
    loginBackgroundColor: string
    dashboardBoxesBackground: DashboardBranding[]
    showPrivacyArea: string
    legalCompanyName: string
    avvUrl: string
    hasDedicatedSupport: boolean
    hasNewsletter: boolean
    publicDataPrivacyUrl: string
    success: string
    publicTOCandLicenceUrl: string
    hasSupport: string
    betaLinkDpa: string
    betaTermsAndConditionsUrl: string
  }
}

export type DashboardBranding = {
  base: string
  border?: string
  polygon?: string
}

// Export features as proxied objects
export const appBranding = createFeatureProxy<AppBranding>('appBranding')
export const iubenda = createFeatureProxy('iubenda')
export const onoffice = createFeatureProxy('onoffice')
export const company = createFeatureProxy<CompanyFeature>('company')
export const supportContact = createFeatureProxy('supportContact')
export const consulting = createFeatureProxy('consulting')
export const signup = createFeatureProxy('signup')
export const dataPrivacy = createFeatureProxy('dataPrivacy')
export const partner = createFeatureProxy('partner')
export const sso = createFeatureProxy('sso')
export const lpEigentumsRadar = createFeatureProxy('lpEigentumsRadar')

export default featuresJson
